var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback } from "react";
import { useMutation, useQuery } from "react-query";
import { CasProfileApi } from "@jti/rest-api";
export const useProfile = () => {
    const callSendOTC = useMutation("sendOTC", (phone) => CasProfileApi.init().sendOTC(phone));
    const callSendEmailOTC = useMutation("sendEmailOTC", (email) => CasProfileApi.init().sendEmailOTC(email));
    const callCheckPhone = useMutation("checkPhone", (phone) => CasProfileApi.init().verifiedPhone(phone));
    const { refetch: getUserProfile } = useQuery("profile", () => CasProfileApi.init().getProfile(), {
        enabled: false,
    });
    const sendOTC = useCallback((phone) => __awaiter(void 0, void 0, void 0, function* () { return yield callSendOTC.mutateAsync(phone); }), [callSendOTC]);
    const sendEmailOTC = useCallback((email) => __awaiter(void 0, void 0, void 0, function* () { return yield callSendEmailOTC.mutateAsync(email); }), [callSendEmailOTC]);
    const checkPhone = useCallback((phone) => __awaiter(void 0, void 0, void 0, function* () { return yield callCheckPhone.mutateAsync(phone); }), [callCheckPhone]);
    return {
        getUserProfile,
        sendOTC,
        sendEmailOTC,
        checkPhone,
    };
};
